import { EulaView } from '../../../common/components/EulaView/EulaView'
import { AzurePricingType } from '../../../modules/privateOffer/reducer'
import { OfferDetails } from '../Sections/OfferDetails'
import { Pricing } from '../Sections/Pricing'
import { PurchaseTerms } from '../Sections/PurchaseTerms'
import { useStyles } from './CombinedFormDetailsAzure.styles'
import { useSelector } from '../../../store'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'
import { CombinedFormHeader } from '../Sections/CombinedFormHeader'
import { microsoftStandardEula } from '../../../common/utils/constants'

export const CombinedFormDetailsAzure = () => {
  const { classes } = useStyles()
  const queryParams = new URLSearchParams(location.search)
  const viewingPersona = queryParams.get('viewing_persona') || ('CP' as string)
  const combinedFormData = useSelector<MsftCombinedFormState>(
    state => state.microsoftCombinedForm
  )
  return (
    <div className={classes.root}>
      <CombinedFormHeader microsoftCombinedFormDetails={combinedFormData} />
      <OfferDetails microsoftCombinedFormDetails={combinedFormData} />
      <PurchaseTerms microsoftCombinedFormDetails={combinedFormData} />
      <Pricing
        plans={combinedFormData?.draftOffer?.plans}
        azurePricingType={AzurePricingType.ABSOLUTE}
        viewingPersona={viewingPersona}
      />
      <EulaView
        eulaHeading={'ISV EULA for buyer'}
        eulaFiles={[microsoftStandardEula]}
        variant="small"
        secondaryEulaHeading={
          viewingPersona === 'CP' ? 'Reseller EULA for buyer' : undefined
        }
        secondaryEulaFiles={
          viewingPersona === 'CP'
            ? combinedFormData?.draftOffer?.resellerEulaFiles
            : undefined
        }
      />
    </div>
  )
}
